module.exports = __webpack_public_path__ + "static/media/br-the-initiative-2.72ee8871.jpg";